<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="targetProductGroups"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-target-product-group") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'targetProductGroups'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-target-product-group
      :modelDialog="targetProductGroupDialog"
      @close="targetProductGroupDialog = false"
    ></add-edit-target-product-group>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditTargetProductGroup from "./admin/AddEditTargetProductGroup.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "TargetGroupProductAdmin",
  components: { AddEditTargetProductGroup, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      targetProductGroupDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      targetProductGroups: (state) => state.targetProductGroups.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.targetProductGroups.editedId
    }),
    pageCount() {
      return Math.ceil(this.targetProductGroups.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "targetProductGroups");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "targetProductGroups");
    },
    openDialog() {
      this.$store.commit("targetProductGroups/setEditedId", -1);
      this.$store.commit(
        "targetProductGroups/setEditedItem",
        Object.assign({}, {})
      );
      this.targetProductGroupDialog = true;
    },
    editItem(item) {
      this.$store.commit("targetProductGroups/setEditedId", item.id);
      this.$store.commit(
        "targetProductGroups/setEditedItem",
        Object.assign({}, item)
      );
      this.targetProductGroupDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.target-product-group"))) {
        this.$store
          .dispatch("targetProductGroups/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.target-product-group-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "targetProductGroups");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.target-product-group-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
